import { Controller } from '@hotwired/stimulus';
import consumer from '../channels/consumer';

export default class extends Controller {
  static targets = ['balance'];

  connect() {
    this.subscriptions = this.#profileIds().map((profileId) =>
      consumer.subscriptions.create(
        { channel: 'WalletBalanceChannel', profile_id: profileId },
        { received: (data) => this.#updateBalance(profileId, data) },
      ),
    );
  }

  disconnect() {
    this.subscriptions?.forEach((subscription) => subscription.unsubscribe());
    this.subscriptions = null;
  }

  #profileIds() {
    const ids = this.balanceTargets.map((target) => target.dataset.profileId);

    return [...new Set(ids)].filter(Boolean);
  }

  #updateBalance(profileId, data) {
    if (data.balance === undefined) return;

    this.balanceTargets
      .filter((target) => target.dataset.profileId === String(profileId))
      .forEach((target) => {
        target.textContent = data.balance;
      });
  }
}
